<template>
  <div class="progress">
    <div
      class="progress__bar"
      :style="{ width: step+'%' }"
    >
      <div class="bar__info">
        <div class="bar__reached">{{ step }}%</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    maxSteps: {
      type: Number,
      default: 1
    },
    currentStep: {
      type: Number,
      default: 1
    }
  },
  computed: {
    step: function () {
      return parseInt(this.currentStep * 100 / this.maxSteps)
    }
  }
}
</script>

<style scoped>

</style>
